import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Footer } from './Footer';
import { GlobalHeader } from './GlobalHeader';
import { ServiceHeader } from './ServiceHeader';
import type { ServiceKey } from '@/data/nav';
import { getPageContent, getRoute, normalizePageUrl } from '@/lib/pageContent';
import { getLang, stripEn } from '@/lib/lang';

const servicePrefixes: Array<[ServiceKey, string]> = [
  ['salon', '/salon/'],
  ['studio', '/studio/'],
  ['apprentice', '/apprentice/'],
  ['shop', '/shop/'],
];

export function SiteLayout() {
  const { pathname } = useLocation();
  // Yuichi 2026-09-16「ページを遷移したら縦スクロールバーは一番上に戻せ」
  useEffect(() => { if (typeof window !== 'undefined') window.scrollTo(0, 0) }, [pathname]);
  const normalizedPath = pathname.endsWith('/') ? pathname : `${pathname}/`;
  // EN ページ(/en/...)は JA 相当の URL でサービス判定。<html class="lang-en"> は CSS の最小調整用(仕様 §2-11)
  const lang = getLang(normalizedPath);
  const jaPath = stripEn(normalizedPath);
  const service = servicePrefixes.find(([, prefix]) => jaPath.startsWith(prefix))?.[0];
  const content = getPageContent(normalizedPath);
  const route = getRoute(normalizedPath);
  const simpleFooter = !route || jaPath === '/404/' || content?.layout === 'legal' || route.kind === 'L' ||
    /\/(?:complete|thanks)\/$/.test(normalizePageUrl(jaPath));
  useEffect(() => {
    if (typeof document === 'undefined') return
    document.documentElement.classList.toggle('lang-en', lang === 'en')
    document.documentElement.classList.toggle('lang-ja', lang === 'ja')
    document.documentElement.lang = lang
  }, [lang]);

  return (
    <div className={`site-layout flex min-h-screen flex-col${lang === 'en' ? ' lang-en' : ''}`}>
      {service ? <ServiceHeader service={service} /> : <GlobalHeader />}
      <Outlet />
      <Footer variant={simpleFooter ? 'simple' : 'sitemap'} />
    </div>
  );
}
